import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Works = () => {
  const { t } = useTranslation();
  const translatedData = t("complexes_data", { returnObjects: true });

  // Массив путей к картинкам. 
  // ВАЖНО: Путь начинается сразу с /assets, так как папка public — это корень сайта.
  const Complexes = [
    { img: "/assets/works/1.png" },
    { img: "/assets/works/2.png" },
    { img: "/assets/works/3.png" },
    { img: "/assets/works/4.png" },
    { img: "/assets/works/5.png" },
    { img: "/assets/works/6.png" },
  ];

  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.2 },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="max-w-7xl m-auto flex flex-col items-center py-[100px]"
    >
      <div
        className={`text-center transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
        }`}
      >
        <h1 className="font-['Cormorant_Garamond'] text-[#0058a3] uppercase text-[20px] md:text-[64px] tracking-[0.15em]">
          {t("works_title")}
        </h1>

        <p className="text-yellow-500 uppercase tracking-[0.6em] text-xl max-sm:text-sm mt-3">
          {t("works_subtitle")}
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-6 mt-10 max-sm:p-6">
        {Complexes.map((item, index) => {
          const fullProjectData = {
            ...item,
            name: translatedData[index]?.name,
            info: translatedData[index]?.info,
          };

          return (
            <Link
              key={index}
              to={`/work/${index}`}
              state={{ project: fullProjectData }}
              className="group w-[400px] max-lg:w-[300px] max-sm:w-full rounded-2xl overflow-hidden shadow-2xl"
            >
              <div className="h-[220px] overflow-hidden">
                <img
                  src={item.img} // Теперь это просто строка "/assets/works/1.png"
                  alt={fullProjectData.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition duration-500"
                />
              </div>

              <div className="p-5 text-center">
                <h3 className="font-['Cormorant_Garamond'] uppercase">
                  {fullProjectData.name || "Loading..."}
                </h3>
              </div>
            </Link>
          );
        })}
      </div>
      <Link 
        className="py-2 px-6 bg-yellow-500 transition-all duration-300 hover:bg-yellow-400 shadow-2xl mt-6 text-white" 
        to={'/works'}
      >
        {t("all_works")}
      </Link>
    </section>
  );
};

export default Works;